// ============ ZEN ERP — Paylaşılan Context'ler ============
// Bu dosya; kimlik doğrulama, UI tercihleri, stok ayarları, navigasyon ve döviz context'lerini içerir.
// App.js ve tüm sayfa modülleri buradan import eder.
import { createContext, useState, useEffect, useCallback } from "react";
import api from "./api";

export const AuthCtx = createContext(null);
export const UICtx = createContext(null);
export const StockSettingsCtx = createContext({ enabled: false, threshold: 10, loaded: false, refresh: () => {} });

/**
 * NavigationCtx — Aktif sekme + alt sekme yönetimi (prop drilling'siz).
 * { activeTab, setTab, subTab, setSubTab }
 */
export const NavigationCtx = createContext({ activeTab: "dashboard", setTab: () => {}, subTab: null, setSubTab: () => {} });

/**
 * RatesCtx — Döviz kurları (TCMB).
 * { rates: { eurToTl, usdToTl, tcmbDate }, loading: bool, refresh: fn }
 */
export const RatesCtx = createContext({ rates: { eurToTl: 38, usdToTl: 34, eurBuy: 37.6, eurSell: 38.0, usdBuy: 33.6, usdSell: 34.0, tcmbDate: "" }, loading: false, refresh: () => {} });

// Kumaş/Parça Stok Takibi aç/kapa + düşük stok eşiği — Ayarlar > Genel'den yönetilir
export function useStockSettingsProvider(ready) {
  const [state, setState] = useState({ enabled: false, threshold: 10, loaded: false });
  const refresh = () => {
    api.get("/settings", { params: { category: "stock" } }).then((r) => {
      const rows = r.data || [];
      const en = rows.find((x) => x.key === "stock_tracking_enabled");
      const th = rows.find((x) => x.key === "stock_min_threshold");
      setState({
        enabled: !!(en && (en.value === true || en.value === "true")),
        threshold: th ? Number(th.value) || 10 : 10,
        loaded: true,
      });
    }).catch(() => setState((s) => ({ ...s, loaded: true })));
  };
  useEffect(() => { if (ready) refresh(); }, [ready]);
  return { ...state, refresh };
}

// Döviz kurlarını merkezi olarak yöneten provider hook'u
export function useRatesProvider(ready) {
  const [rates, setRates] = useState({ eurToTl: 38, usdToTl: 34, eurBuy: 37.6, eurSell: 38.0, usdBuy: 33.6, usdSell: 34.0, tcmbDate: "" });
  const [loading, setLoading] = useState(false);
  const refresh = useCallback(() => {
    setLoading(true);
    api.get("/rates").then((r) => {
      setRates({
        eurToTl:  r.data?.eurToTl  || 38,
        usdToTl:  r.data?.usdToTl  || 34,
        eurBuy:   r.data?.eurBuy   || r.data?.eurToTl  || 37.6,
        eurSell:  r.data?.eurSell  || r.data?.eurToTl  || 38.0,
        usdBuy:   r.data?.usdBuy   || r.data?.usdToTl  || 33.6,
        usdSell:  r.data?.usdSell  || r.data?.usdToTl  || 34.0,
        tcmbDate: r.data?.tcmbDate || "",
      });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);
  useEffect(() => { if (ready) refresh(); }, [ready, refresh]);
  return { rates, loading, refresh };
}

